import './usp-product.scss';

import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';

class UspProduct {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-uspproduct',
            sliderAttr: 'slider',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$uspProduct = $element;
        this.$uspProductContainer = this.$uspProduct.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$uspProductSlides = this.$uspProduct.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.uspProduct = null;

        if (this.$uspProductContainer && this.$uspProductSlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        if (!window.mediaMatchHandler[1024].matches) {
            this.initSlider();
        }

        this.setEvents();
    }

    setEvents () {
        window.mediaMatchHandler[1024].addEventListener('change', (match) => {
            if (!match.matches) {
                this.initSlider();
            } else {
                this.destroySlider();
            }
        });
    }

    initSlider () {
        this.uspProduct = new Swiper(this.$uspProductContainer, {
            effect: 'slide',
            modules: [Pagination, A11y],
            cardsEffect: {
                slideShadows: false
            },
            speed: 500,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            slidesPerGroupAuto: true,
            centeredSlides: true,
            centeredSlidesBounds: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });

        this.sliderActive = true;
    }

    destroySlider () {
        if (this.uspProduct !== null) {
            this.uspProduct.destroy(true, true);
            this.uspProduct = null;
        }
    }
}

export { UspProduct };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$uspProduct = $context.querySelectorAll('[data-uspproduct="root"]');
        for (let i = 0; i < $$uspProduct.length; i++) {
            const $uspProduct = $$uspProduct[i];

            const uspProductAPI = new UspProduct($uspProduct);
            $uspProduct.API = uspProductAPI;
        }
    }
});
